import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBar } from '@nivo/bar';
import defaultTheme from '../theme';
import { merge } from 'es-toolkit';
import { useSelector } from 'react-redux';

const BarChart = (props) => {
    const { KUserSettings } = useSelector(state => state.userSettings);
    const {
        data,
        keys,
        axisBottomLegend,
        axisBottomTickRotation,
        axisBottomFormat,
        axisBottomLegendOffset,
        axisLeftLegend,
        axisLeftFormat,
        labelFormat,
        tooltipFormat,
        enableLabel,
        theme,
        scheme,
        layout,
        labelTextColor,
        label,
        noLegend,
        customMargin,
        marginBottom: marginBottomProp,
        indexBy = 'id',
        horizontalLabelWidth,
    } = props;

    const is_horizontal = layout === 'horizontal';

    const axisBottom = {
        tickSize: 5,
        tickPadding: is_horizontal ? 8 : 5,
        tickRotation: is_horizontal ? 0 : axisBottomTickRotation,
        legend: axisBottomLegend,
        legendPosition: 'middle',
        legendOffset: axisBottomLegendOffset != null ? axisBottomLegendOffset : (is_horizontal ? 48 : 45),
        format: axisBottomFormat,
    };

    const axisLeft = is_horizontal ? {
        tickSize: 0,
        tickPadding: 8,
        tickRotation: 0,
        format: axisLeftFormat,
    } : (axisLeftLegend ? {
        tickSize: 5,
        tickPadding: 5,
        legend: axisLeftLegend,
        legendPosition: 'middle',
        legendOffset: -45,
        format: axisLeftFormat,
    } : null);

    const legends = [{
        dataFrom: 'keys',
        anchor: 'bottom-right',
        direction: 'column',
        justify: false,
        translateX: 120,
        translateY: 0,
        itemsSpacing: 2,
        itemWidth: 100,
        itemHeight: 20,
        itemTextColor: KUserSettings.darkTheme ? '#fff' : '#000',
    }];

    const marginBottomDefault = is_horizontal
        ? (axisBottomLegend ? 72 : 56)
        : (axisBottomTickRotation === 0 ? 50 : 110);
    const marginBottom = typeof marginBottomProp === 'number' ? marginBottomProp : marginBottomDefault;
    const chartTheme        = merge(KUserSettings.darkTheme ? defaultTheme.dark : defaultTheme.light, theme);
    const optional          = {};

    if (!noLegend)
        optional.legends = legends;

    const horizontal_left = typeof horizontalLabelWidth === 'number'
        ? horizontalLabelWidth
        : 220;

    const defaultMargins = is_horizontal ? {
        top: 12,
        right: 28,
        bottom: marginBottom,
        left: horizontal_left,
    } : {
        top: 30,
        right: 130,
        bottom: marginBottom,
        left: 60,
    };
    const chartMargins = typeof customMargin === 'number'
        ? {
            top: customMargin,
            right: customMargin,
            bottom: marginBottom,
            left: customMargin,
        }
        : typeof customMargin === 'object' && customMargin != null
            ? { ...defaultMargins, ...customMargin }
            : defaultMargins;

    return (

        <ResponsiveBar
            data={data}
            keys={keys}
            indexBy={indexBy}
            padding={0.3}
            margin={chartMargins}
            colors={{ scheme: scheme }}
            theme={chartTheme}
            axisBottom={axisBottom}
            axisLeft={axisLeft}
            labelSkipWidth={12}
            labelSkipHeight={12}
            tooltipFormat={tooltipFormat}
            labelFormat={labelFormat}
            enableLabel={enableLabel}
            labelTextColor={labelTextColor}
            layout={layout}
            label={label}
            {...optional}
        />
    );
}

BarChart.defaultProps = {
    axisBottomLegend: null,
    axisBottomTickRotation: 0,
    axisBottomFormat: undefined,
    axisBottomLegendOffset: undefined,
    axisLeftLegend: null,
    axisLeftFormat: undefined,
    labelTextColor: "white",
    enableLabel: true,
    theme: {},
    scheme: 'category10',
    marginBottom: undefined,
    indexBy: 'id',
    horizontalLabelWidth: undefined,
};

BarChart.propTypes = {
    axisBottomLegend: PropTypes.string,
    axisBottomTickRotation: PropTypes.number,
    axisBottomFormat: PropTypes.func,
    axisBottomLegendOffset: PropTypes.number,
    axisLeftLegend: PropTypes.string,
    axisLeftFormat: PropTypes.func,
    enableLabel: PropTypes.bool,
    theme: PropTypes.object,
    scheme: PropTypes.string,
    marginBottom: PropTypes.number,
    customMargin: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    indexBy: PropTypes.string,
    horizontalLabelWidth: PropTypes.number,
};

export default BarChart;
